var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.011 7.025c-6.988-.297-16.17 2.107-19.887 3.346 9.48 0 14.963 0 15.241 2.51.28 2.51-15.241 11.06-17.286 12.175-1.636.892-1.053.93-.558.837 1.611-.28 6.45-1.58 12.919-4.554 8.084-3.718 14.59-8.179 15.705-9.666 1.115-1.487 2.603-4.275-6.134-4.647z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrb);
export default __webpack_public_path__ + "static/media/TRB.194ce975a6c4ec277d69ffd103d158ce.svg";
export { ForwardRef as ReactComponent };